"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  small: 576,
  medium: 752,
  large: 1024,
  xlarge: 1152
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/utilities/breakpoints.js
// module id = 275
// module chunks = 4